export const invalidateBranchLifecycleQueries = (queryClient, {placeId, branchId}) => {
    void queryClient.invalidateQueries({queryKey: ["admin-places"]});
    void queryClient.invalidateQueries({queryKey: ["admin-place"]});
    void queryClient.invalidateQueries({queryKey: ["admin-place", String(placeId)]});
    if (branchId !== null && branchId !== undefined) {
        void queryClient.invalidateQueries({queryKey: ["admin-branch"]});
        void queryClient.invalidateQueries({queryKey: ["admin-branch", String(branchId)]});
    }
    void queryClient.invalidateQueries({queryKey: ["admin-place-operations-summary"]});
};
